import { Avatar, Box, Typography, IconButton, Menu, MenuItem, Button, useMediaQuery, ListItemText } from "@mui/material"
import { retrieveSpecialistInfo } from "../../../../redux/admin-slices/specialist.slice"
import { useParams, useLocation } from "react-router-dom"
import Icons from "../../../../assets/js/Icons"
import SpecialistDetailSidebar from "./Sidebar"
import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"

function SpecialistDetailLayout() {
  const dispatch = useDispatch()
  const { userId } = useParams()
  const location = useLocation()
  const [data, setData] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"))

  const handleRetrieveAll = () => {
    dispatch(retrieveSpecialistInfo({ userId }))
      .unwrap()
      .then(setData)
      .catch(() => { })
  }

  useEffect(() => {
    if (userId) handleRetrieveAll()
    // eslint-disable-next-line
  }, [userId])

  const specialist = data

  const menuItems = [
    { label: "Details", path: `/specialist/detail/${userId}` },
    { label: "Members", path: `/specialist/detail/${userId}/members` },
    {
      label: "Appointments",
      path: `/specialist/detail/${userId}/appointments`,
    },
    {
      label: "Wallet",
      path: `/specialist/detail/${userId}/wallet`,
    },
  ]

  const open = Boolean(anchorEl)
  const handleMenuClick = (event) => setAnchorEl(event.currentTarget)
  const handleMenuClose = () => setAnchorEl(null)

  return (
    <Box sx={{ display: "flex", bgcolor: "#ececec", p: 2, minHeight: "100%" }}>
      <SpecialistDetailSidebar />

      <Box width={{ xs: "100%", xl: "calc(100% - 250px)" }} pl={{ xs: 0, xl: 2 }}>
        <Box sx={{ mb: 2 }}>
          <Button
            component={Link}
            to="/specialists/all"
            variant="text"
            startIcon={<ArrowBackIcon />}
            sx={{
              textTransform: "none",
              fontWeight: "600",
              fontFamily: "Poppins",
              color: "other.color1"
            }}
          >
            Back to Specialists
          </Button>
        </Box>
        <Box width="100%" position="relative">
          <Box
            sx={{
              p: 1.5,
              gap: 1,
              borderRadius: 3,
              display: "flex",
              bgcolor: "white",
              flexWrap: "nowrap",
            }}
          >
            <Box
              sx={{
                p: 0.5,
                border: "2px solid",
                alignSelf: "center",
                borderRadius: "100px",
                borderColor: "primary.main",
              }}
            >
              <Avatar
                sx={{
                  width: { sm: 60, md: 100 },
                  height: { sm: 60, md: 100 },
                }}
                src={specialist?.image}
              />
            </Box>
            <ListItemText
              primary={specialist?.name || "N/A"}
              secondary={
                <Box>
                  <Typography fontSize={{ xs: 14, md: 16 }}><Typography component="span" fontSize={{ xs: 14, md: 16 }} fontWeight={500}>Email:</Typography> {specialist?.email || "-"}</Typography>
                  <Typography fontSize={{ xs: 14, md: 16 }}><Typography component="span" fontSize={{ xs: 14, md: 16 }} fontWeight={500}>Phone:</Typography> {specialist?.phone || "-"}</Typography>
                </Box>
              }
              slotProps={{
                secondary: { component: "div" },
                primary: { sx: { fontSize: { xs: 16, md: 24 }, fontWeight: "700", textTransform: "capitalize" } },
              }}
            />
          </Box>
          <Box
            sx={{
              top: 8,
              right: 8,
              zIndex: 1,
              position: "absolute",
              display: { xl: "none" },
            }}
          >
            <IconButton onClick={handleMenuClick} size={sm ? "medium" : "large"}>
              <Icons.Menu />
            </IconButton>
          </Box>
        </Box>
        <Box width="100%">
          <Outlet />
        </Box>
      </Box>

      {/* Mobile Menu Dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path
          return (
            <MenuItem key={item.path} onClick={handleMenuClose}>
              <Button
                component={Link}
                to={item.path}
                variant={isActive ? "activeMobileMenu" : "mobileMenu"}
              >
                {item.label}
              </Button>
            </MenuItem>
          )
        })}
      </Menu>
    </Box>
  )
}

export default SpecialistDetailLayout